import { useEffect, useState } from "react";
import { Card, Container, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";

//interfaces
import { VerificacionInterface } from "../../../../interfaces/VerificacionInterface";

//estilos
const classes = require("./VerificacionDetalle.module.css").default;

/**
 * VerificacionDetalle
 * @description: Componente que permite editar un verificacion.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de verificacions.
 */

const VerificacionDetalle = () => {
  const { idVerificacion } = useParams();
  const { sendRequest } = useFetch();
  const [verificacion, setVerificacion] = useState<VerificacionInterface>();

  //Función que trata el detalle de verificacion.
  const transformData = (variable: any) => {
    setVerificacion(variable.data);
  };

  useEffect(() => {
    sendRequest(
      {
        url: `/verificacion/${idVerificacion}`,
      },
      transformData
    );
  }, [idVerificacion, sendRequest]);

  //mientras se carga el detalle se muestra un spinner
  if (!verificacion) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="danger" />
      </div>
    );
  }

  return (
    <Container style={{ marginTop: "20px" }}>
      <h2>Detalle de la verificacion {idVerificacion} </h2>
      <Card style={{ width: "18rem" }} className={"mx-auto"}>
        <Card.Body>
          <Card.Title>{verificacion.nombre}</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            {`${verificacion.nombre}`}
          </Card.Subtitle>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default VerificacionDetalle;
